import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';

export const selectMortgageMonthlyPaymentTo = createSelector(
  selectJsonQuery,
  jsonQuery => getTermValue('mortgage_monthly_payment_to')(jsonQuery) || undefined,
);
